import type { StarterCard, StarterDeck } from "./types";

/**
 * Compact builder for starter decks. Accepts cards as tuples to keep the deck
 * files readable:
 *
 *   starterDeck({
 *     id: "en-ru-food-a1",
 *     ...
 *     cards: [
 *       ["apple", "яблоко"],
 *       ["bread", "хлеб", "phrase"],  // 3-tuple if entity type matters
 *     ],
 *   });
 */
type CardTuple =
  | [front: string, back: string]
  | [front: string, back: string, entityType: StarterCard["entityType"]];

export function starterDeck(
  input: Omit<StarterDeck, "cardCount" | "cards" | "loadCards"> & { cards: CardTuple[] },
): StarterDeck {
  const cards = input.cards.map(([front, back, entityType]) => ({
    front,
    back,
    ...(entityType ? { entityType } : {}),
  }));

  return {
    ...input,
    cardCount: cards.length,
    cards,
  };
}
